// eslint-disable-next-line import/no-absolute-path, import/extensions
import '/app/app/nordic-pages/landing-buyers/index.desktop.scss';
import { hydrateNordicPage } from 'frontend-page/hydrate';
// eslint-disable-next-line import/no-absolute-path, import/extensions
import View from '/app/app/nordic-pages/landing-buyers/index.js';

hydrateNordicPage({ View });
